import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import AppNavbar from "../../components/common/AppNavbar";

const SouthKoreaVisaGuide = () => {
  const categories = [
    {
      name: "Apply for Visa (Embassy/Consulate)",
      link: "https://overseas.mofa.go.kr/",
    },
    {
      name: "Tourist Visa (C-3)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "Business Visa (C-3-4)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "K-ETA (Visa-Free Nationals)",
      link: "https://www.k-eta.go.kr/",
    },
    {
      name: "Work Visas (E-1 to E-7)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "Student Visa (D-2)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "General Training Visa (D-4)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "Marriage / Family Visa (F-3, F-6)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "Investor / Business Visa (D-8)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "Permanent Residency (F-5)",
      link: "https://www.visa.go.kr/",
    },
    {
      name: "Citizenship (Naturalization)",
      link: "https://www.immigration.go.kr/",
    },
  ];

  return (
    <>
      <AppNavbar />
      <Container fluid className="my-4">
        <Row>
          <Col lg={9}>
            <h4 className="my-4 fw-bold">
              General Guidance on South Korea Immigration and Visas
            </h4>
            <ul>
              <li>
                <b>Visa Types:</b>
                <ul>
                  <li>
                    <b>Short-Stay (up to 90 days):</b> Tourist Visa (C-3),
                    Business Visa (C-3-4), Transit Visa, Visa-Free Entry (with
                    K-ETA).
                  </li>
                  <li>
                    <b>Long-Stay:</b> Work Visas (E-1 to E-7), Student Visa
                    (D-2), Training Visa (D-4), Family/Marriage Visas (F-3,
                    F-6), Investor Visa (D-8).
                  </li>
                  <li>
                    <b>Permanent Options:</b> Permanent Residency (F-5),
                    Citizenship through naturalization.
                  </li>
                </ul>
              </li>
              <li>
                <b>Requirements:</b> Valid passport, visa form, photos,
                itinerary, proof of funds, insurance, and purpose-specific
                documents (job contract, admission letter, marriage certificate,
                business registration).
              </li>
              <li>
                <b>Application Process:</b>
                <ul>
                  <li>Choose visa type according to purpose of stay.</li>
                  <li>Apply at nearest Korean Embassy/Consulate.</li>
                  <li>Provide biometrics (if required).</li>
                  <li>
                    Processing: Short-term 5–15 days; Long-term several weeks.
                  </li>
                  <li>
                    On arrival: Apply for Alien Registration Card (ARC) within
                    90 days for long-term stays.
                  </li>
                </ul>
              </li>
              <li>
                <b>Tips for Success:</b> Apply well in advance, prepare
                translations, register with immigration for long-term stays, and
                ensure K-ETA approval for visa-free travelers.
              </li>
              <li>
                <b>Helpful Resources:</b>{" "}
                <a
                  href="https://www.immigration.go.kr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Korea Immigration Service (HiKorea)
                </a>
                ,{" "}
                <a
                  href="https://www.k-eta.go.kr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  K-ETA Official Site
                </a>
                .
              </li>
            </ul>

            <Row className="g-0">
              {categories.map((category, index) => (
                <Col
                  lg={4}
                  key={index}
                  className="d-flex align-items-center p-2 border rounded shadow-sm bg-light hover-effect"
                >
                  <a
                    href={category.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {category.name}
                  </a>
                </Col>
              ))}
            </Row>

            <div className="text-center py-4">
              <h6 style={{ fontSize: "11px" }}>ADVERTISEMENT</h6>
              <div className="text-center">
                {/* Mobile */}
                <Row className="d-md-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Maroon+traditional+Minimal+Guru+Purnima+Greeting+Instagram+Post.gif"
                      alt="Mobile"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Tablet */}
                <Row className="d-none d-md-flex d-lg-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
                      alt="Tablet"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Desktop */}
                <Row className="d-none d-lg-flex">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
                      alt="Desktop"
                      className="img-fluid"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          {/* Sidebar Ads */}
          <Col lg={3} md={3}>
            <div className="d-flex justify-content-center">
              <small>Advertisement</small>
            </div>

            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2 border"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Maroon+traditional+Minimal+Guru+Purnima+Greeting+Instagram+Post.gif"
                fluid
              />
            </Link>
            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Brown+Illustrative+Krishna+Janmashtami+Greeting+Instagram+Post+(1).gif"
                fluid
              />
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SouthKoreaVisaGuide;
